import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import TrustBadges from "../TrustBadges/TrustBadges";

class FooterLinks extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="footer-alt">
          <Container>
            <Row>
              <Col lg={12}>
                <TrustBadges />
                <div className="float-start pull-none">
                  <p className="copy-rights text-muted">
                    {new Date().getFullYear()} © RediMD, LLC. - All rights reserved
                  </p>
                </div>
                <div className="float-end pull-none">
                  <img
                    src="assets/images/payment.png"
                    alt="payment"
                    height="36"
                  />
                </div>
                <div className="clearfix"></div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default FooterLinks;
